export const SET_REPORTING_CONFIG = 'SET_REPORTING_CONFIG'



// WEBPACK FOOTER //
// ./src/types/reporting.js